import React from 'react';
import { getVariantPath } from '@uswitch/ev-utils/get-variant-path';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
export var stylePath = function stylePath(field, variant) {
  return getVariantPath({
    atomicType: 'elements',
    componentId: 'logo-collection',
    variantName: variant,
    field: field
  });
};

var LogoCollection = function LogoCollection(_ref) {
  var logoImage = _ref.logoImage,
      className = _ref.className,
      variant = _ref.variant;
  return _jsx("div", {
    sx: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center',
      variant: stylePath('outer', variant)
    },
    className: className,
    children: logoImage.map(function (img, i) {
      return _jsx("div", {
        sx: {
          variant: stylePath('inner', variant)
        },
        children: img
      }, img.key || i);
    }, this)
  });
};

export default LogoCollection;
//# sourceMappingURL=index.js.map